import { Route, Routes } from 'react-router-dom';
import SolumSaasSuiteLayout from './SolumSaasSuiteLayout';
import FunctionAssignment from './FunctionAssignment';
import OfflineLabelsAdmin from './OfflineLabelsAdmin';
import OfflineGatewayAnalysis from './OfflineGatewayAnalysis';
import MainHomepage from './MainHomepage';

function SolumSaasSuite() {
  return (
    <SolumSaasSuiteLayout>
      <Routes>
        <Route path="/main-homepage" element={<MainHomepage />} />
        <Route path="/function-assignment" element={<FunctionAssignment />} />
        <Route path="/offline-labels" element={<OfflineLabelsAdmin />} />
        <Route path="/offline-gateways" element={<OfflineGatewayAnalysis />} />
      </Routes>
    </SolumSaasSuiteLayout>
  );
}

export default SolumSaasSuite;